import { addDays } from 'date-fns';

import isSelectable from './isSelectable';
import isSelected from './isSelected';
import { BlankCalendarDay, DateObj, DatePickerDate } from '../types';

// This is 6 weeks of days, we always want to show 6 weeks in a calendar month display
// so that all months remain a constant size
const CALENDAR_LIMIT = 42;

export default function fillBackWeek({
  lastDayOfMonth,
  minDate,
  maxDate,
  selectedDates,
  calendarLength,
  showOutsideDays,
}: {
  lastDayOfMonth: Date;
  minDate?: DatePickerDate | null;
  maxDate?: DatePickerDate | null;
  selectedDates: (DatePickerDate | null)[] | null;
  calendarLength: number;
  showOutsideDays?: boolean;
}) {
  const dates: (BlankCalendarDay | DateObj)[] = [];
  const limit = CALENDAR_LIMIT - calendarLength;

  if (showOutsideDays) {
    const firstDayOfNextMonth = addDays(lastDayOfMonth, 1);
    const nextDateMonth = firstDayOfNextMonth.getMonth();
    const nextDateYear = firstDayOfNextMonth.getFullYear();

    // Fill out back week for days from
    // following month with dates from next month.
    let counter = 0;
    while (counter < limit) {
      const date = new Date(nextDateYear, nextDateMonth, 1 + counter);
      const dateObj = {
        date,
        isOutside: true,
        selected: isSelected(selectedDates, date),
        selectable: isSelectable({ minDate, maxDate, date }),
        today: false,
        prevMonth: false,
        nextMonth: true,
      };
      dates.push(dateObj);
      counter++;
    }
  } else {
    // Fill out back week for days from
    // following month with buffer.
    let day = 0;
    while (day < limit) {
      dates.push('');
      day++;
    }
  }

  return dates;
}
